const REACT_APP_API_URL: string =
  process.env.REACT_APP_API_URL || "https://api.west-cut.com/operator";

export const env = {
  REACT_APP_API_URL,
};
